import { QueryKey as OriginQueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEY } from '@query/keys';
import { ApiRepository } from '@repositories/api';

import type {
  GetSellerCountListRequestPayload,
  SellerCountListResponseOK,
  SellerCountListResponseError
} from '@repositories/api/statistics.types';
import type { AxiosResponse } from 'axios';

type Props<Data extends AxiosResponse, ErrorResponse, QueryKey extends OriginQueryKey> = {
  queryParams: GetSellerCountListRequestPayload['queryParams'];
  options?: Omit<
    UseQueryOptions<Data, ErrorResponse, Data['data']['data'], QueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >;
};

function useGetSellerCountListQuery<
  Data extends SellerCountListResponseOK,
  ErrorResponse extends SellerCountListResponseError
>({
  queryParams,
  options
}: Props<Data, ErrorResponse, ReturnType<typeof QUERY_KEY.STATISTICS.GET_SELLER_COUNT_LIST>>) {
  return useQuery({
    queryKey: QUERY_KEY.STATISTICS.GET_SELLER_COUNT_LIST({ queryParams }),
    queryFn: () => {
      return ApiRepository.statistics.getSellerCountList({ queryParams });
    },
    select: (data) => data.data.data,
    ...options
  });
}

export { useGetSellerCountListQuery };
